import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IAbstractView } from '@core/interfaces';
import { IconPresenter } from './icon.presenter';
import { IIconComponent, IIconPresenter } from './interfaces';

@Component({
	selector: 'app-icon',
	templateUrl: './icon.component.html',
	styleUrls: ['./icon.component.scss'],
	imports: [CommonModule],
	providers: [IconPresenter],
	host: {
    '[class.icon]': 'true'
  },
	standalone: true,
})
export class IconComponent extends IAbstractView<IIconPresenter> implements IIconComponent {
	translations = this.presenter.translations;
	iconElement = this.presenter.iconElement;

	@Input() loading$ = this.presenter.loading$;
	@Input({ required: true }) iconName = this.presenter.iconName;

	constructor(presenter: IconPresenter) {
		super(presenter);
	}
}
